import React, { useState, useEffect } from 'react';
import { Stack } from '@mui/material';
import { UseFormReturn } from 'react-hook-form';

import { SftpConfigSetInput } from 'generated/graphql';
import { controlledTextField } from 'components/ReactHookForm/controlledTextField';
import PasswordInput from 'components/PasswordInput';

import { STUB_PASSWORD } from '../stubPassword';

const HostInput = controlledTextField<Required<SftpConfigSetInput>>()('host', {
  rules: { required: true },
});
const PortInput = controlledTextField<Required<SftpConfigSetInput>>()('port', {
  rules: { required: true, min: 0, max: 65535 },
});
const UsernameInput = controlledTextField<Required<SftpConfigSetInput>>()('username', {
  rules: { required: true },
});

const SFTPConnectionForm = ({
  formMethods: {
    control,
    watch,
    setValue,
    getValues,
    formState: { isDirty },
  },
  isSecretSet,
}: {
  formMethods: UseFormReturn<Required<SftpConfigSetInput>, unknown>;
  isSecretSet?: boolean;
}) => {
  const [visibilityControlDisabled, setVisibilityControlDisabled] = useState(true);

  useEffect(() => {
    watch((value, { name }) => {
      if (name === 'password' && Boolean(value.password) && value.password !== STUB_PASSWORD) {
        setVisibilityControlDisabled(false);
      } else {
        setVisibilityControlDisabled(true);
      }
    });
  }, [watch]);

  return (
    <>
      <Stack spacing={3}>
        <HostInput controllerProps={{ control }} label="Host" type="text" />
        <PortInput controllerProps={{ control }} label="Port" type="number" />
        <UsernameInput controllerProps={{ control }} label="Username" type="text" />
        <PasswordInput
          disableVisibilityControl={visibilityControlDisabled}
          onFocus={() => {
            const passwordValue = getValues('password');
            if (passwordValue === STUB_PASSWORD) {
              setValue('password', '');
            }
          }}
          required={!isSecretSet}
          helperText={
            isDirty &&
            isSecretSet &&
            (!getValues('password') || getValues('password') === STUB_PASSWORD)
              ? 'Password will not be updated when you save the change'
              : ''
          }
        />
      </Stack>
    </>
  );
};

export default SFTPConnectionForm;
